import { Helmet } from "react-helmet-async";
//import previewImage from "../assets/LGC.webp";

const SITE_NAME = "Intellegnium Diseñadores";
const SITE_URL = "https://intellegniumdisenadores.com";
const DEFAULT_IMAGE = "https://intellegniumdisenadores.com/preview.jpg";
const DESCRIPCION = "Agencia creativa especializada en branding, ilustración, animación , botargas, registro de marca y diseño gráfico.";

export default function SEO({
  title,
  description=DESCRIPCION,
  image = DEFAULT_IMAGE,
  url = SITE_URL,
}) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : SITE_NAME;

  return (
    <Helmet>
      <title>{fullTitle}</title>

      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={image} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content="Intellegnium Diseñadores" />
    </Helmet>
  );
}